import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";
import ImageProtection from "@/components/common/ImageProtection";
import { PromoStickyMobile } from "@/components/common/PromoKit";

export default function Layout() {
  return (
    <div className="min-h-screen bg-white text-ink">
      <ImageProtection />
      <Header />
      <main className="pt-[108px] min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <PromoStickyMobile />
      <Toaster theme="light" position="top-right" richColors />
    </div>
  );
}
